<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-valentine">
      <div class="px-3 col-3 p-0">
        <div class="heading-valentine">{{ $t("result.round") }}</div>
        <div class="text-subhead-valentine">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-valentine">
          {{ $t("result.bet") + `${currency}` }}
        </div>
        <div class="text-subhead-valentine">
          {{ this.data.count === 0
            ? this.data.bet
            : this.data.detail.summary[this.data.count].bet.amount | currencyFormatter
          }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-valentine">
          {{ $t("result.winlose") + `${currency}` }}
        </div>
        <div class="text-subhead-valentine">
          {{ (this.winlose) | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-valentine">
          {{ $t("result.balance") + `${currency}` }}
        </div>
        <div class="text-subhead-valentine">
          {{ (this.balance) | currencyFormatter }}
        </div>
      </div>
    </div>
    <div class="content-result-valentine pt-3">
      <div class="text-games-valentine">{{ "Cupid's Garden" }}</div>
      <div class="text-subgame-valentine">{{ $t("valentine.name") }}</div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>
      <div class="col-12 justify-content-center d-flex flex-row p-0" style="margin-top: 100px">
        <div class="col-1 d-flex align-items-center justify-content-center" style="color: white">
          <i v-if="isFreespin || isRespin" class="fas fa-caret-left arrow-side-valentine" @click="delCount()"></i>
        </div>

        <div class="d-flex col-10 table-valentine container" />

        <div class="d-flex flex-column">
          <div class="top-reel justify-content-center">
            <div class="" v-for="(row, index) in this.newReel[6]" :key="index">
              <img class="icon-symbol-valentine" :src="require(`../../assets/resultGame/valentine/1/symbol_${row[0]}.png`)
                " alt="" />
            </div>
          </div>

          <div class="d-flex flex-row slot-container">
            <div class="d-flex flex-column">
              <div v-for="(reel, index) in this.newReel[0]" :key="index">
                <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-valentine" :src="require(`../../assets/resultGame/valentine/${reel[1]}/symbol_${reel[0]}.png`)" alt="" />
                <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/valentine/${reel[1]
                  }/symbol_${reel[0] - 13}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/valentine/silver${reel[1]}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-valentine" :src="require(`../../assets/resultGame/valentine/${reel[1]
                  }/symbol_${reel[0] - 24}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/valentine/gold${reel[1]}.png`)
                  " alt="" />
              </div>
            </div>
            <div class="d-flex flex-column">
              <div class="" v-for="(reel, index) in this.newReel[1]" :key="index">
                <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-valentine" :src="require(`../../assets/resultGame/valentine/${reel[1]}/symbol_${reel[0]}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-valentine" :src="require(`../../assets/resultGame/valentine/${reel[1]
                  }/symbol_${reel[0] - 13}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/valentine/silver${reel[1]}.png`)" alt="" />
                <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-valentine" :src="require(`../../assets/resultGame/valentine/${reel[1]
                  }/symbol_${reel[0] - 24}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/valentine/gold${reel[1]}.png`)" alt="" />
              </div>
            </div>
            <div class="d-flex flex-column">
              <div class="" v-for="(reel, index) in this.newReel[2]" :key="index">
                <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-valentine" :class="`-level${reel[1]}`"
                  :src="require(`../../assets/resultGame/valentine/${reel[1]}/symbol_${reel[0]}.png`)
                    " alt="" />
                <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-valentine" :src="require(`../../assets/resultGame/valentine/${reel[1]
                  }/symbol_${reel[0] - 13}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/valentine/silver${reel[1]}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-valentine" :src="require(`../../assets/resultGame/valentine/${reel[1]
                  }/symbol_${reel[0] - 24}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/valentine/gold${reel[1]}.png`)
                  " alt="" />
              </div>
            </div>
            <div class="d-flex flex-column">
              <div class="" v-for="(reel, index) in this.newReel[3]" :key="index">
                <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-valentine" :src="require(`../../assets/resultGame/valentine/${reel[1]}/symbol_${reel[0]}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-valentine" :src="require(`../../assets/resultGame/valentine/${reel[1]
                  }/symbol_${reel[0] - 13}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/valentine/silver${reel[1]}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-valentine" :src="require(`../../assets/resultGame/valentine/${reel[1]
                  }/symbol_${reel[0] - 24}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/valentine/gold${reel[1]}.png`)
                  " alt="" />
              </div>
            </div>
            <div class="d-flex flex-column">
              <div class="" v-for="(reel, index) in this.newReel[4]" :key="index">
                <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-valentine" :src="require(`../../assets/resultGame/valentine/${reel[1]}/symbol_${reel[0]}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-valentine" :src="require(`../../assets/resultGame/valentine/${reel[1]
                  }/symbol_${reel[0] - 13}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/valentine/silver${reel[1]}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-valentine" :src="require(`../../assets/resultGame/valentine/${reel[1]
                  }/symbol_${reel[0] - 24}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/valentine/gold${reel[1]}.png`)
                  " alt="" />
              </div>
            </div>
            <div class="d-flex flex-column">
              <div class="" v-for="(reel, index) in this.newReel[5]" :key="index">
                <img v-if="reel[0] >= 0 && reel[0] <= 12" class="icon-symbol-valentine" :src="require(`../../assets/resultGame/valentine/${reel[1]}/symbol_${reel[0]}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol-valentine" :src="require(`../../assets/resultGame/valentine/${reel[1]
                  }/symbol_${reel[0] - 13}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 13 && reel[0] <= 23" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/valentine/${reel[1]
                  }/symbol_${reel[0] - 13}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol-valentine" :src="require(`../../assets/resultGame/valentine/${reel[1]
                  }/symbol_${reel[0] - 24}.png`)
                  " alt="" />
                <img v-if="reel[0] >= 24 && reel[0] <= 34" class="icon-symbol" :class="`-level${reel[1]}`" :src="require(`../../assets/resultGame/valentine/gold${reel[1]}.png`)
                  " alt="" />
              </div>
            </div>
          </div>
        </div>

        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!this.isEndRound" class="fas fa-caret-right arrow-side-valentine" @click="addCount()"></i>
        </div>
      </div>
      <div class="text-center py-4 text-games-valentine">
        <h1 v-if="isFreespin">
          FREESPIN {{ this.data.count + 1 }}/{{ this.data.detail.summary.length }}
        </h1>
        <h1 v-else>SPIN {{ this.data.count + 1 }}/{{ this.data.detail.summary.length }}</h1>
      </div>
      <div v-if="this.winnings.length > 0" class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3" />
        <div class="text-detail align-items-center d-flex px-3">
          {{ $t("result.detail") }}
        </div>
        <hr class="line col-3" />
      </div>
      <div v-if="data.detail.featureBuy" class="text-subgame-valentine">
        Feature Buy
      </div>

      <div v-if="this.winnings.length" class="col-12 justify-content-start d-flex flex-row">
        <div class="
            bet-box-valentine
            p-2
            px-3
            justify-content-start
            align-items-start
            container
          ">
          <div class="text-multiplier">
            <h1 class="my-1 green">
              Multiplier x {{ this.multiplier }}
            </h1>
          </div>
          <div class="bet-warpper item" v-for="(detail, index) in this.winnings" :key="index">
            <div class="d-flex item justify-content-between px-1 mb-2">
              <div class="bet-wrapper-valentine item win-box d-flex">
                <div class="
                    d-flex
                    justify-content-between
                    bet-wrapper-valentine
                    item
                  ">
                  <div class="d-flex flex-row">
                    <img class="icon-detail-valentine" :src="require(`../../assets/resultGame/valentine/1/symbol_${detail.symbol}.png`)
                      " alt="" />
                    <div class="
                        d-flex
                        flex-column
                        align-items-start
                        justify-content-center
                      ">
                      <p class="my-1 green ml-2">
                        {{ ` ${detail.row} ` + $t("result.kind") + ` x${detail.count} ${detail.count > 1 ? `lines` :
                        `line`}` }}
                      </p>
                    </div>
                  </div>
                  <div class="d-flex flex-column justify-content-center px-3">
                    <p class="my-1">{{ currency }} {{ detail.amount | currencyFormatter }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-valentine",
  props: {
    data: Object,
    page: Number,
    isback: Boolean
  },
  data() {
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      tokenData: utils.getTokenData(this.$route.query.t),
      date: "",
      time: "",
      balance: 0,
      bet: 0,
      count: 0,
      currency: this.data.currency ? this.data.currency : "THB",
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      isFreespin: false,
      multiplier: 0,
      reels: [],
      reelSizes: [],
      newReel: [],
      pages: 0,
      winnings: [],
      isEndRound: false,
      pagesCount: 0,
      round: 1,
      winlose: 0,
    };
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight =
        document.getElementsByClassName("header-valentine")[0].offsetHeight;
    },
    async mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.isFreespin =
        result.state === "FREESPIN" ||
        result.state === "FREERESPIN";
      this.isRespin = result.state === "RESPIN";
      this.reels = result.reels;
      this.reelSizes = result.reelSizes;
      this.multiplier = result.multiplier;
      this.winlose = result.win;
      this.bet = result.bet;
      this.newReel = await this.mapTable(this.reels, this.reelSizes);
      this.freeSpinData = result.freeSpin;
      this.round = this.isFreespin ? this.freeSpinData.round : result.round;
      this.pagesCount = this.isFreespin ? this.freeSpinData.remain : result.round;
      this.winnings = result.winnings;
      this.balance = result.balance;
      this.isEndRound = result.isEndRound;

      if (result.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
    async mapTable(reel, reelSize) {
      let newMap = [];
      let newReel = [];
      for (let i = 0; i < reel.length; i++) {
        newReel = [];
        for (let j = 0; j < reel[i].length; j++) {
          let symbolMap = [reel[i][j], reelSize[i][j]];
          newReel.push(symbolMap);
        }
        newMap.push(newReel);
      }
      return newMap;
    },
  },
};
</script>

<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #292933;
  /* margin: 0; */
}

img {
  pointer-events: none;
  cursor: default;
}

.wheel-wrapper {
  position: absolute;
  width: 570px;
  height: 100%;
  top: 7px;
}

.fg-image {
  width: 570px;
}

.multiplier-wrapper {
  top: -95px;
  z-index: 6;
  height: 134px;
  overflow: hidden;
}

.multiplier-image {
  width: 90%;
  transform: scale(0.9);
  margin-left: 21px;
}

.icon-detail-valentine {
  width: 100px;
  height: 80px;
  padding: 4px;
}

.icon-bonus-valentine {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-valentine {
  cursor: pointer;
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-valentine {
  /* background: #0c161f; */
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 800px;
}

.bonus-box-valentine {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-valentine .item {
  color: #fff;
  /* background: #06112d; */
  line-height: 1;
  border-radius: 10px;
  /* border: 1.5px solid #cac095; */
}

.bet-box-valentine .bet-wrapper-valentine:not(:first-child) .item {
  margin-top: 10px;
  width: 800px;
}

.bet-wrapper-valentine,
.result-wrapper {
  font-size: 35px;
  width: 800px;
}

.header-valentine {
  background: #901ab4;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-valentine>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-valentine {
  color: #000000;
  text-align: center;
}

.content-result-valentine {
  background: #fd73c0;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-valentine {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-valentine {
  color: #ffffff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-valentine {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-subgame-valentine {
  font-size: 20px;
  color: #ffd500;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #fff;
  text-align: center;
}

.icon-symbol-valentine {
  width: 100%;
  /* padding: 5%; */
}

.bet-box-valentine {
  min-width: 600px;
  max-width: auto;
}

.win-box {
  width: 760px;
}

.icon-symbol {
  position: absolute;
  transform: translate(-108px, 0px);
}

.icon-symbol.-level1 {
  width: 109px;
  height: 89px;
}

.icon-symbol.-level2 {
  width: 109px;
  height: 176px;
}

.icon-symbol.-level3 {
  width: 109px;
  height: 266px;
}

.icon-symbol.-level4 {
  width: 112px;
  height: 352px;
}

.table-valentine {
  background: url("~@/assets/resultGame/valentine/slotmachine.png") no-repeat;
  z-index: 5;
  background-size: 763px 186px;
  /* set Bg Table HERE */
  width: 763px;
  height: 268px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
  margin-top: 48px;
  position: absolute;
  z-index: 0;
  transform: translate(0px, -130px);
}

.slot-container {
  position: relative;
}

.top-reel {
  display: flex;
  flex-direction: row;
  position: relative;
}

.table-pos {
  transform: translate(0px, -7px);
}

.text-multiplier {
  width: 689px;
  text-align: center;
}

@media screen and (max-width: 1030px) {
  .table-valentine {
    background-size: 760px 181px;
    width: 760px;
    height: 268px;
    transform: translate(0px, -124px);
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -107px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-valentine {
    min-width: 580px;
    max-width: auto;
    height: 280px;
  }

  .bet-wrapper-valentine {
    width: 800px
  }

  .result-wrapper {
    font-size: 35px;
    width: 800px
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-126px, 0px);
  }

  .icon-symbol.-level1 {
    width: 127px;
    height: 104px;
  }

  .icon-symbol.-level2 {
    width: 126px;
    height: 209px;
  }

  .icon-symbol.-level3 {
    width: 127px;
    height: 314px;
  }

  .icon-symbol.-level4 {
    width: 127px;
    height: 419px;
  }
}

@media screen and (min-width: 1060px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -115px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 570px;
    margin-left: -34px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(1);
    margin-left: 21px;
  }

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-valentine,
  .result-wrapper {
    font-size: 33px;
    width: 800px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-127px, 0px);
  }

  .icon-symbol.-level1 {
    width: 127px;
    height: 105px;
  }

  .icon-symbol.-level2 {
    width: 126px;
    height: 210px;
  }

  .icon-symbol.-level3 {
    width: 127px;
    height: 315px;
  }

  .icon-symbol.-level4 {
    width: 126px;
    height: 419px;
  }
}

.line {
  background-color: #fff;
  height: 2px;
  width: 100%;
  font-size: 28px;
}

.red {
  color: #ff0000;
}

.green {
  color: #fff;
  font-size: 28px;
}

.win-box {
  width: 689px;
}

@media screen and (max-width: 900px) {
  .table-valentine {
    background-size: 747px 178px;
    width: 747px;
    height: 180px;
    transform: translate(0px, -122px);
  }

  .top-reel {
    width: 67%;
    transform: translate(124px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-124px, 0px);
  }

  .icon-symbol.-level1 {
    width: 126px;
    height: 103px;
  }

  .icon-symbol.-level2 {
    width: 124px;
    height: 205px;
  }

  .icon-symbol.-level3 {
    width: 124px;
    height: 309px;
  }

  .icon-symbol.-level4 {
    width: 124px;
    height: 412px;
  }
}

@media screen and (max-width: 870px) {
  .table-valentine {
    background-size: 723px 169px;
    width: 723px;
    height: 180px;
    transform: translate(0px, -117px);
  }

  .top-reel {
    width: 67%;
    transform: translate(120px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-121px, 0px);
  }

  .icon-symbol.-level1 {
    width: 121px;
    height: 100px;
  }

  .icon-symbol.-level2 {
    width: 121px;
    height: 199px;
  }

  .icon-symbol.-level3 {
    width: 121px;
    height: 300px;
  }

  .icon-symbol.-level4 {
    width: 121px;
    height: 399px;
  }
}

@media screen and (max-width: 840px) {
  .table-valentine {
    background-size: 675px 169px;
    width: 723px;
    height: 180px;
    transform: translate(0px, -117px);
  }

  .top-reel {
    width: 67%;
    transform: translate(113px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-113px, 0px);
  }

  .icon-symbol.-level1 {
    width: 113px;
    height: 93px;
  }

  .icon-symbol.-level2 {
    width: 113px;
    height: 186px;
  }

  .icon-symbol.-level3 {
    width: 113px;
    height: 278px;
  }

  .icon-symbol.-level4 {
    width: 113px;
    height: 371px;
  }
}

@media screen and (max-width: 800px) {
  .table-valentine {
    background-size: 659px 152px;
    width: 653px;
    height: 180px;
    transform: translate(0px, -108px);
  }

  .top-reel {
    width: 67%;
    transform: translate(111px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-111px, 0px);
  }

  .icon-symbol.-level1 {
    width: 110px;
    height: 92px;
  }

  .icon-symbol.-level2 {
    width: 111px;
    height: 183px;
  }

  .icon-symbol.-level3 {
    width: 111px;
    height: 275px;
  }

  .icon-symbol.-level4 {
    width: 111px;
    height: 367px;
  }
}

@media screen and (max-width: 780px) {
  .top-reel {
    display: flex;
    flex-direction: row;
    position: relative;
    width: 67%;
    transform: translate(105px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-107px, 0px);
  }

  .icon-symbol.-level1 {
    width: 107px;
    height: 89px;
  }

  .icon-symbol.-level2 {
    width: 107px;
    height: 177px;
  }

  .icon-symbol.-level3 {
    width: 107px;
    height: 264px;
  }

  .icon-symbol.-level4 {
    width: 106px;
    height: 352px;
  }
}

@media screen and (max-width: 770px) {
  .heading-valentine {
    font-size: 18px;
  }

  .table-valentine {
    background-size: 638px 164px;
    width: 638px;
    height: 268px;
    margin-bottom: 1%;
    transform: translate(0px, -121px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-valentine {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-valentine {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 67%;
    transform: translate(104px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-107px, 0px);
  }

  .icon-symbol.-level1 {
    width: 107px;
    height: 89px;
  }

  .icon-symbol.-level2 {
    width: 107px;
    height: 177px;
  }

  .icon-symbol.-level3 {
    width: 107px;
    height: 264px;
  }

  .icon-symbol.-level4 {
    width: 106px;
    height: 352px;
  }
}

@media screen and (max-width: 740px) {
  .heading-valentine {
    font-size: 18px;
  }

  .table-valentine {
    background-size: 593px 164px;
    width: 638px;
    height: 268px;
    margin-bottom: 1%;
    transform: translate(0px, -121px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-valentine {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-valentine {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 66%;
    transform: translate(100px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-99px, 0px);
  }

  .icon-symbol.-level1 {
    width: 99px;
    height: 82px;
  }

  .icon-symbol.-level2 {
    width: 99px;
    height: 165px;
  }

  .icon-symbol.-level3 {
    width: 99px;
    height: 244px;
  }

  .icon-symbol.-level4 {
    width: 99px;
    height: 326px;
  }
}

@media screen and (max-width: 710px) {
  .heading-valentine {
    font-size: 18px;
  }

  .table-valentine {
    background-size: 565px 164px;
    width: 638px;
    height: 268px;
    margin-bottom: 1%;
    transform: translate(0px, -121px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-valentine {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-valentine {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 66%;
    transform: translate(95px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-94px, 0px);
  }

  .icon-symbol.-level1 {
    width: 94px;
    height: 78px;
  }

  .icon-symbol.-level2 {
    width: 94px;
    height: 155px;
  }

  .icon-symbol.-level3 {
    width: 94px;
    height: 232px;
  }

  .icon-symbol.-level4 {
    width: 94px;
    height: 311px;
  }
}

@media screen and (max-width: 680px) {
  .heading-valentine {
    font-size: 18px;
  }

  .table-valentine {
    background-size: 566px 164px;
    width: 638px;
    height: 268px;
    margin-bottom: 1%;
    transform: translate(0px, -121px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-valentine {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-valentine {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 66%;
    transform: translate(95px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-95px, 0px);
  }

  .icon-symbol.-level1 {
    width: 94px;
    height: 78px;
  }

  .icon-symbol.-level2 {
    width: 94px;
    height: 155px;
  }

  .icon-symbol.-level3 {
    width: 95px;
    height: 233px;
  }

  .icon-symbol.-level4 {
    width: 95px;
    height: 303px;
  }
}

@media screen and (max-width: 650px) {
  .heading-valentine {
    font-size: 18px;
  }

  .table-valentine {
    background-size: 543px 164px;
    width: 638px;
    height: 268px;
    margin-bottom: 1%;
    transform: translate(0px, -121px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-valentine {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-valentine {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 66%;
    transform: translate(91px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-91px, 0px);
  }

  .icon-symbol.-level1 {
    width: 91px;
    height: 75px;
  }

  .icon-symbol.-level2 {
    width: 91px;
    height: 149px;
  }

  .icon-symbol.-level3 {
    width: 91px;
    height: 224px;
  }

  .icon-symbol.-level4 {
    width: 91px;
    height: 297px;
  }
}

@media screen and (max-width: 620px) {
  .heading-valentine {
    font-size: 18px;
  }

  .table-valentine {
    background-size: 516px 130px;
    width: 638px;
    height: 268px;
    margin-bottom: 1%;
    transform: translate(0px, -105px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-valentine {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-valentine {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 66%;
    transform: translate(87px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-85px, 0px);
  }

  .icon-symbol.-level1 {
    width: 86px;
    height: 71px;
  }

  .icon-symbol.-level2 {
    width: 86px;
    height: 142px;
  }

  .icon-symbol.-level3 {
    width: 86px;
    height: 211px;
  }

  .icon-symbol.-level4 {
    width: 86px;
    height: 283px;
  }
}

@media screen and (max-width: 600px) {
  .table-valentine {
    background-size: 498px 114px;
    width: 498px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .top-reel {
    width: 67%;
    transform: translate(82px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-83px, 0px);
  }

  .icon-symbol.-level1 {
    width: 83px;
    height: 70px;
  }

  .icon-symbol.-level2 {
    width: 83px;
    height: 138px;
  }

  .icon-symbol.-level3 {
    width: 83px;
    height: 207px;
  }

  .icon-symbol.-level4 {
    width: 83px;
    height: 275px;
  }
}

@media screen and (max-width: 570px) {
  .table-valentine {
    background-size: 474px 114px;
    width: 498px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .top-reel {
    width: 66%;
    transform: translate(80px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-78px, 0px);
  }

  .icon-symbol.-level1 {
    width: 79px;
    height: 65px;
  }

  .icon-symbol.-level2 {
    width: 83px;
    height: 138px;
  }

  .icon-symbol.-level3 {
    width: 83px;
    height: 207px;
  }

  .icon-symbol.-level4 {
    width: 79px;
    height: 261px;
  }
}

@media screen and (max-width: 540px) {
  .table-valentine {
    background-size: 446px 114px;
    width: 498px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .top-reel {
    width: 66%;
    transform: translate(76px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-73px, 0px);
  }

  .icon-symbol.-level1 {
    width: 74px;
    height: 62px;
  }

  .icon-symbol.-level2 {
    width: 73px;
    height: 124px;
  }

  .icon-symbol.-level3 {
    width: 83px;
    height: 207px;
  }

  .icon-symbol.-level4 {
    width: 74px;
    height: 245px;
  }
}

@media screen and (max-width: 510px) {
  .table-valentine {
    background-size: 402px 114px;
    width: 498px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .top-reel {
    width: 66%;
    transform: translate(68px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-67px, 0px);
  }

  .icon-symbol.-level1 {
    width: 67px;
    height: 54px;
  }

  .icon-symbol.-level2 {
    width: 67px;
    height: 110px;
  }

  .icon-symbol.-level3 {
    width: 67px;
    height: 165px;
  }

  .icon-symbol.-level4 {
    width: 67px;
    height: 220px;
  }
}


@media screen and (max-width: 480px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-valentine>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-valentine {
    font-size: 12px;
  }

  .table-valentine {
    background-size: 399px 100px;
    width: 399px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .text-subhead-valentine {
    font-size: 14px;
  }

  .bet-box-valentine {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bonus-box-valentine {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-valentine {
    width: 422px;
  }

  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-valentine {
    width: 45px;
    height: 50px;
  }

  .text-multiplier {
    width: 422px;
  }

  .icon-bonus-valentine {
    width: 60px;
    height: 60px;
  }

  .top-reel {
    width: 67%;
    transform: translate(66px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-67px, 0px);
  }

  .icon-symbol.-level1 {
    width: 67px;
    height: 56px;
  }

  .icon-symbol.-level2 {
    width: 67px;
    height: 110px;
  }

  .icon-symbol.-level3 {
    width: 67px;
    height: 165px;
  }

  .icon-symbol.-level4 {
    width: 67px;
    height: 220px;
  }
}

@media screen and (max-width: 450px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-valentine>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-valentine {
    font-size: 12px;
  }

  .table-valentine {
    background-size: 375px 100px;
    width: 399px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .text-subhead-valentine {
    font-size: 14px;
  }

  .bet-box-valentine {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bonus-box-valentine {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-valentine {
    width: 422px;
  }

  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-valentine {
    width: 45px;
    height: 50px;
  }

  .text-multiplier {
    width: 422px;
  }

  .icon-bonus-valentine {
    width: 60px;
    height: 60px;
  }

  .top-reel {
    width: 67%;
    transform: translate(61px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-62px, 0px);
  }

  .icon-symbol.-level1 {
    width: 62px;
    height: 52px;
  }

  .icon-symbol.-level2 {
    width: 62px;
    height: 103px;
  }

  .icon-symbol.-level3 {
    width: 62px;
    height: 155px;
  }

  .icon-symbol.-level4 {
    width: 62px;
    height: 206px;
  }
}

@media screen and (max-width: 420px) {

  .table-valentine {
    background-size: 350px 100px;
    width: 399px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .top-reel {
    width: 66%;
    transform: translate(59px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-58px, 0px);
  }

  .icon-symbol.-level1 {
    width: 58px;
    height: 48px;
  }

  .icon-symbol.-level2 {
    width: 58px;
    height: 96px;
  }

  .icon-symbol.-level3 {
    width: 58px;
    height: 145px;
  }

  .icon-symbol.-level4 {
    width: 58px;
    height: 193px;
  }
}

@media screen and (max-width: 390px) {

  .table-valentine {
    background-size: 325px 100px;
    width: 399px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .top-reel {
    width: 66%;
    transform: translate(55px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-54px, 0px);
  }

  .icon-symbol.-level1 {
    width: 54px;
    height: 44px;
  }

  .icon-symbol.-level2 {
    width: 54px;
    height: 86px;
  }

  .icon-symbol.-level3 {
    width: 54px;
    height: 134px;
  }

  .icon-symbol.-level4 {
    width: 54px;
    height: 179px;
  }
}

@media screen and (max-width: 360px) {

  .table-valentine {
    background-size: 300px 100px;
    width: 399px;
    height: 180px;
    transform: translate(0px, -93px);
  }

  .top-reel {
    width: 66%;
    transform: translate(51px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-50px, 0px);
  }

  .icon-symbol.-level1 {
    width: 50px;
    height: 42px;
  }

  .icon-symbol.-level2 {
    width: 50px;
    height: 82px;
  }

  .icon-symbol.-level3 {
    width: 50px;
    height: 123px;
  }

  .icon-symbol.-level4 {
    width: 50px;
    height: 165px;
  }
}

@media screen and (max-width: 340px) {

  .table-valentine {
    background-size: 279px 100px;
    width: 399px;
    height: 180px;
    transform: translate(2px, -93px);
  }

  .top-reel {
    width: 66%;
    transform: translate(48px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-47px, 0px);
  }

  .icon-symbol.-level1 {
    width: 47px;
    height: 38px;
  }

  .icon-symbol.-level2 {
    width: 47px;
    height: 77px;
  }

  .icon-symbol.-level3 {
    width: 47px;
    height: 115px;
  }

  .icon-symbol.-level4 {
    width: 47px;
    height: 154px;
  }
}

@media screen and (max-width: 320px) {

  .table-valentine {
    background-size: 259px 64px;
    width: 399px;
    height: 180px;
    transform: translate(4px, -76px);
  }

  .top-reel {
    width: 66%;
    transform: translate(44px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-44px, 0px);
  }

  .icon-symbol.-level1 {
    width: 44px;
    height: 36px;
  }

  .icon-symbol.-level2 {
    width: 44px;
    height: 71px;
  }

  .icon-symbol.-level3 {
    width: 44px;
    height: 107px;
  }

  .icon-symbol.-level4 {
    width: 44px;
    height: 143px;
  }
}
</style>